// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.contactemail.RentalManagerUserPropertyContactEmailV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyContactEmailDeliverabilityResponseV2WebDto,
  UserPropertyContactEmailPurgeV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyContactEmailV2WebApiHandler_purge_Path =
  '/api/web/v2/users/properties/contactEmail/purge';

/**
 * Purge contact email with bounce or spam report
 */
export const RentalManagerUserPropertyContactEmailV2WebApiHandler_purge = (
  postData: UserPropertyContactEmailPurgeV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyContactEmailPurgeV2RequestDto,
    UserPropertyContactEmailDeliverabilityResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyContactEmailV2WebApiHandler_purge_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
